import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['dragContainer']

  connect() {
    var dragula = require('dragula');

    this.drake = dragula({
      containers: Array.from(this.dragContainerTargets),
      invalid: (el, handle) => el.classList.contains('no-drag')
    });

    this.drake.on('drop', this.changePosition.bind(this))
  }

  changePosition(el, target, source, sibling) {
    var fieldTemplateId = this.dragContainerTarget.getAttribute("data-field-template-id");
    var elementId = el.getAttribute("data-field-option-id");
    var siblingId = null;

    // input element near the dropped board field
    if(sibling.tagName === "INPUT") {
      sibling = sibling.nextElementSibling
    }
    
    if(sibling !== null) {
      siblingId = sibling.getAttribute("data-field-option-id");
    }

    let data = { id: elementId, sibling_field_id: siblingId, field_template_id: fieldTemplateId };

    fetch(`/${accountId}/field_template_options/${elementId}/update_position`, {
      method: "PATCH",
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (!response.ok) {
        throw response
      }
      return response.json();
    }).then((responseJson) => {
      responseJson
    }).catch((error) => {
      console.log(error)
    })
  }

}